export default __webpack_public_path__ + "static/eniyan_1_1_de-e5dc938fc23b96dcdcffdc6d5ed4cff1.jpg";